var _defs, _style, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 428 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "P",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g1",
    x1: 87.1,
    y1: 246.6,
    x2: 333.6,
    y2: 0,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00aaff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g2",
    x1: 81.2,
    y1: 512,
    x2: 346,
    y2: 247.3,
    href: "#P"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00aaff"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".s0{fill:url(#g1)}.s1{fill:url(#g2)}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m123.2 210.5c-24-24-36.2-53.3-36.2-87.2c0-33.9 12.3-63.3 36.2-87.2c23.9-23.9 53.4-36.1 87.2-36.1c33.8 0 63.1 12.1 87.1 36.1c24 24 36.2 53.3 36.2 87.2c0 33.9-12.3 63.2-36.2 87.2c-23.9 24-53.3 36.1-87.1 36.1c-33.9 0-63.2-12.1-87.2-36.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m427.2 423.9c0 26.8-8.8 48.7-25.3 64.4c-16.5 15.7-38.4 23.7-65.1 23.7h-246.5c-26.6 0-48.4-7.7-65.1-23.7c-16.7-16-25.2-37.6-25.2-64.4c0-10.2 0.3-20.4 1-30.2q0.3-4.1 0.7-8.1q0.4-4.1 1-8.1q0.5-4 1.1-8.1q0.7-4 1.4-8q0.7-4.1 1.6-8.2q0.8-4.2 1.8-8.2q1-4.1 2.1-8.2q1.1-4 2.4-8q1.3-3.9 2.8-7.8q1.4-3.9 3.1-7.7q1.7-3.8 3.6-7.5q1.8-3.7 3.9-7.3q2-3.6 4.3-7.1q2.3-3.5 4.8-6.8q2.6-3.3 5.3-6.4q2.8-3.1 5.8-6q3.1-2.9 6.5-5.6q3.4-2.6 7.1-4.9q3.6-2.3 7.5-4.2q3.8-1.9 7.8-3.5q4.4-1.7 9-3q4.5-1.2 9.2-2.1q4.6-0.8 9.4-1.2q4.7-0.4 9.4-0.4c5.2 0 10.3 2.2 20 8.5l20.9 13.5c6.7 4.3 15.8 8.3 27 11.9q8 2.6 16.3 4q8.3 1.3 16.8 1.3q8.4 0 16.7-1.3q8.3-1.4 16.3-4c11.2-3.6 19.1-6.9 27-11.9c7.9-5 14.9-9.6 20.9-13.5c9.8-6.3 14.8-8.5 20-8.5q4.7 0 9.4 0.4q4.8 0.4 9.4 1.2q4.7 0.8 9.2 2.1q4.6 1.3 9 3q4 1.6 7.9 3.5q3.8 1.9 7.5 4.2q3.6 2.3 7 4.9q3.5 2.7 6.6 5.6q3 2.9 5.7 6q2.8 3.1 5.4 6.4q2.5 3.3 4.8 6.8q2.3 3.5 4.3 7.1q2 3.6 3.9 7.3q1.8 3.7 3.5 7.5q1.7 3.8 3.1 7.7q1.5 3.9 2.8 7.8q1.3 4 2.4 8q1.1 4.1 2.1 8.2q1 4 1.9 8.2q0.9 4.1 1.6 8.2q0.7 4 1.3 8q0.7 4.1 1.2 8.1q0.5 4 0.9 8.1q0.4 4 0.7 8.1c0.7 9.8 1.1 19.9 1.1 30.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f2d7f539767f1b6f76f06f7012fc14bc.svg";
export { ForwardRef as ReactComponent };